import { Component, Input, OnInit } from "@angular/core";
import { User } from "@nousmedis/guard-types/frontend";
import { SideMenuService } from "app/modules/menus/services/sideMenu.service";
import { AuthModel } from "@nousmedis/nm-guard-auth";
import { LayoutService } from "app/layout/service/app.layout.service";

@Component({
    selector: "cc-top-menu",
    templateUrl: "./top-menu.component.html",
    styleUrls: ["./top-menu.component.scss"],
})
export class TopMenuComponent implements OnInit {
    user: User;
    inconMenu = "menu";
    sidenavIsExpanded: boolean = false;
    org: any;
    @Input() context: string;

    constructor (
        private sidenavService: SideMenuService,
        private auth: AuthModel,
        private layoutService: LayoutService
    ) {
        this.user = this.auth.getCurrentUser();
        if (this.user) {
            this.org = this.auth.getCurrentUserOrg(this.user.id);
        }
    }

    ngOnInit(): void {}

    onMenuButtonClick() { this.layoutService.onMenuToggle(); }

    toogleSideNav() {
        this.sidenavIsExpanded = !this.sidenavIsExpanded;
        this.sidenavService.toggle();
    }
}
